type WebkitElement = HTMLElement & { webkitRequestFullscreen?: () => Promise<void> };
type WebkitDocument = Document & {
  webkitFullscreenElement?: Element | null;
  webkitExitFullscreen?: () => Promise<void>;
};

export async function requestFullscreen(el: HTMLElement = document.documentElement): Promise<void> {
  const webkit = el as WebkitElement;
  try {
    if (typeof el.requestFullscreen === 'function') {
      await el.requestFullscreen();
      return;
    }
    if (typeof webkit.webkitRequestFullscreen === 'function') {
      await webkit.webkitRequestFullscreen();
      return;
    }
  } catch (err) {
    throw new Error(
      `Fullscreen non disponibile (${err instanceof Error ? err.message : 'errore sconosciuto'})`,
    );
  }
  throw new Error('Fullscreen API non supportata da questo browser');
}

export async function exitFullscreen(): Promise<void> {
  const webkitDoc = document as WebkitDocument;
  if (typeof document.exitFullscreen === 'function' && document.fullscreenElement !== null) {
    await document.exitFullscreen();
    return;
  }
  if (typeof webkitDoc.webkitExitFullscreen === 'function' && webkitDoc.webkitFullscreenElement) {
    await webkitDoc.webkitExitFullscreen();
  }
}

export function isFullscreen(): boolean {
  const webkitDoc = document as WebkitDocument;
  return (
    document.fullscreenElement !== null || (webkitDoc.webkitFullscreenElement ?? null) !== null
  );
}

export function onFullscreenChange(cb: () => void): () => void {
  document.addEventListener('fullscreenchange', cb);
  document.addEventListener('webkitfullscreenchange', cb);
  return () => {
    document.removeEventListener('fullscreenchange', cb);
    document.removeEventListener('webkitfullscreenchange', cb);
  };
}
